import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styles from './UltraExistingMember.module.scss';
import AppPaths from '../../../AppPaths';

/**
 * "Already a Fi member?" callout on the Ultra PDP — routes existing members to
 * the login flow so they can add an Ultra under their current membership.
 */
export default function UltraExistingMember() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.existingMemberBox}>
      <div className={styles.existingMemberText}>
        <div className={styles.existingMemberTitle}>{t('ultra_already_member')}</div>
        <div className={styles.existingMemberDescription}>{t('ultra_bundle_description')}</div>
      </div>
      <div className={styles.loginAction}>
        <button
          type="button"
          className={styles.loginLink}
          onClick={() => {
            history.push(AppPaths.Login);
          }}
        >
          <span className={styles.loginLabel}>{t('ultra_log_in')}</span>
        </button>
      </div>
    </div>
  );
}
